<template lang="html">
  <footer :class="{ 'showFooter': !hideFooter }">
    <div class="NaviGrid">
      <div></div>
      <ul v-for="(route, index) in showRoutes(1)"
          class="main"
          :class="{ 'main-last': index === showRoutes(1).length - 1 }"
          v-bind:key="route.title">
        <li>{{ route.title }}</li>

        <li v-for="subroute in subRoutes(route.id)"
            v-bind:key="subroute.title">
          <router-link :to="{ path: subroute.route }"
                       :title="subroute.title">
            {{ subroute.title }}
          </router-link>
        </li>
        <!-- Social Component for desktop - only in last menu item -->
        <li v-if="index === showRoutes(1).length - 1"
            class="social-item">
          <Social />
        </li>
      </ul>
    </div>

    <div class="LogoGrid">
      <Logo />
      <div class="Copyright">
        <!-- Desktop: Social above copyright -->
        <Social v-if="windowWidth >= 768" />
        <div class="copyright-text">
          <strong>&copy; Christo and Jeanne-Claude Foundation</strong>
          All images on this website are copyrighted.
          <router-link :to="{ name: 'privacy', params: {} }"
                       class="link">
            Privacy Policy
          </router-link>
        </div>
      </div>
      <!-- Mobile: Social below copyright -->
      <Social v-if="windowWidth < 768" />
    </div>
  </footer>
</template>

<script>
import Social from "@/components/Elements/ElSocial.vue";
import Logo from "@/components/Elements/ElLogo.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Social,
    Logo,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      hideFooter: true,
    };
  },
  computed: {
    ...mapGetters(["pageRoutes"]),
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.hideFooter = true;
    setTimeout(() => {
      this.hideFooter = false;
    }, 1000);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    showRoutes(selector) {
      let items = null;
      if (selector == 1) {
        items = this.pageRoutes.filter((route) => route.is_menu_top == 1);
      }

      if (selector == 3) {
        items = this.pageRoutes.filter((route) => route.is_menu_top == 2);
      }

      items.sort((a, b) =>
        a.is_order > b.is_order ? 1 : b.is_order > a.is_order ? -1 : 0
      );
      return items;
    },
    subRoutes(id) {
      const items = this.pageRoutes.filter((route) => route.is_menu_sub == id);
      items.sort((a, b) =>
        a.is_menu_top > b.is_menu_top
          ? 1
          : b.is_menu_top > a.is_menu_top
            ? -1
            : 0
      );
      return items;
    },
  },
};
</script>
<style>
footer {
  background: #222929;
  padding: 12px;
  margin-top: 48px;
  opacity: 0;
  transition: opacity 1s;
}

footer.showFooter {
  opacity: 1;
}

footer .link {
  color: white;
  border-bottom: 1px solid white;
  padding-bottom: 1px;
}

footer .NaviGrid {
  display: none;
}

footer .LogoGrid {
  margin-top: 6px;
}

footer .Logo img {
  max-width: 400px;
}

footer .Copyright {
  color: white;
  font-size: 0.55rem;
  line-height: 1.1rem;
  margin-top: 6px;
  margin-bottom: 36px;
}

footer .LogoGrid .Social {
  display: grid;
  grid-gap: 6px;
  grid-template-columns: min-content min-content min-content;
}

footer .Social img {
  width: 30px;
  height: 30px;
}

@media only screen and (min-width: 600px) {
  footer {
    padding: 24px;
    margin-top: 48px;
  }

  footer .Copyright {
    font-size: 0.5rem;
    margin-bottom: 36px;
    white-space: nowrap;
  }
}

@media only screen and (min-width: 768px) {
  footer {
    margin-top: 72px;
  }

  footer .NaviGrid {
    display: grid !important;
    width: 100%;
    padding: 0 !important;
    grid-column-gap: 24px;
    grid-template-columns: repeat(12, 1fr);
    user-select: none;
  }

  footer .NaviGrid .main {
    display: block;
    white-space: nowrap;
    grid-row-start: 1;
  }

  footer .NaviGrid .main li {
    display: block;
    font-size: 0.75rem;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    color: white;
    width: calc(100% + 20px);
    cursor: pointer;
  }

  footer .LogoGrid .Social {
    display: grid;
    grid-gap: 6px;
    grid-template-columns: min-content min-content min-content;
  }

  /* Hide the social buttons from the NaviGrid on desktop */
  footer .NaviGrid .main li.social-item {
    display: none;
  }

  footer .Social {
    margin-top: 6px !important;
  }

  footer .Social img {
    width: 27px !important;
    height: 27px !important;
    filter: invert(0) !important;
  }

  footer .NaviGrid ul li:first-child {
    position: relative;
    display: block;
    padding: 0;
    border: none;
    margin: 0;
    margin-bottom: 6px;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    line-height: 1.4rem;
    cursor: auto;
  }

  footer a {
    color: white !important;
  }

  footer .Else ul li:last-child {
    border-bottom: none !important;
  }

  footer .NaviGrid .main:nth-child(2) {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  footer .NaviGrid .main:nth-child(3) {
    grid-column-start: 3;
    grid-column-end: 5;
  }

  footer .NaviGrid .main:nth-child(4) {
    grid-column-start: 5;
    grid-column-end: 7;
  }

  footer .NaviGrid .main:nth-child(5):not(.main-last) {
    grid-column-start: 7;
    grid-column-end: 13;
  }

  /* Default: 5th child takes full remaining space when there's room */
  footer .NaviGrid .main:nth-child(5) {
    grid-column-start: 7;
    grid-column-end: 13;
  }

  /* Only apply last positioning when space is constrained */
  footer .NaviGrid .main.main-last {
    position: relative;
    grid-column-end: 13;
    justify-self: end;
    text-align: right;
  }

  /* Override ALL li elements in the last menu */
  footer .NaviGrid .main.main-last li {
    width: 100% !important;
    text-align: right;
  }

  /* Social item within last menu - align right */
  footer .NaviGrid .main li.social-item {
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: right;
    margin-top: 6px;
    width: auto !important;
  }

  footer .NaviGrid .main li.social-item .Social {
    justify-content: flex-end;
  }

  footer .NaviGrid .Else {
    grid-template-rows: min-content auto;
  }

  footer .LogoGrid {
    margin-top: 48px;
    display: grid;
    grid-column-gap: 24px;
    grid-template-columns: 1fr min-content;
    justify-content: end;
    align-items: end;
  }

  footer .Logo {
    grid-column: 1;
    grid-row: 1;
    align-self: end;
  }

  footer .Copyright {
    grid-column: 2;
    grid-row: 1;
    font-size: 0.5rem;
    margin-bottom: 3px;
    white-space: nowrap;
    user-select: none;
    align-self: end;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  footer .Copyright .Social {
    display: grid !important;
    grid-gap: 6px;
    grid-template-columns: min-content min-content min-content;
    margin-bottom: 6px;
  }

  footer .Copyright .copyright-text {
    color: white;
  }
}

@media only screen and (min-width: 900px) {
  footer {
    padding: 24px 36px;
    margin-top: 90px;
  }

  footer .LogoGrid {
    margin-top: 72px;
  }

  footer .Copyright {
    font-size: 0.6rem;
  }

  footer .LogoGrid img {
    max-width: 720px;
    width: calc(50%);
  }

  footer .Social img {
    width: 30px !important;
    height: 30px !important;
    filter: invert(0) !important;
  }

  /* Enhanced typography for larger screens */
  footer .NaviGrid .main li {
    font-size: 0.8rem;
    line-height: 1.7rem;
  }

  footer .NaviGrid ul li:first-child {
    margin-bottom: 9px;
    font-size: 0.9rem;
    line-height: 1.4rem;
  }
}
</style>
